import { useQuery } from 'react-query';
import { Paginated, User } from 'src/core/types';

import axios from './axios';

const fetchUsers = (page = 1) =>
  axios
    .get<Paginated<User>>(`/posht/ashena/users/pending/?page=${page}`)
    .then((res) => res.data);

export interface UsePendingUserProps {
  page?: number;
}

export function usePendingUsers(props: UsePendingUserProps = {}) {
  const { page } = props;

  return useQuery<Paginated<User>>(['pending-users', page], async () => {
    return fetchUsers(page);
  });
}
